import { Layout } from '../components/Layout';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';

export const PrivacyPolicyPage = () => {
  return (
    <Layout>
      <div className="section-spacing" data-testid="privacy-policy-page">
        <div className="container-luxury max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="text-center mb-12">
              <Shield className="h-12 w-12 text-[#C6A87C] mx-auto mb-4" />
              <h1 className="font-heading text-3xl md:text-4xl text-[#2C2420] mb-4">
                Privacy Policy
              </h1>
              <p className="text-[#5D5550]">Last updated: February 2025</p>
            </div>

            <div className="prose prose-lg max-w-none space-y-8">
              <section>
                <h2 className="font-heading text-xl text-[#2C2420] mb-4">1. Information We Collect</h2>
                <p className="text-[#5D5550] leading-relaxed">
                  When you make a purchase or attempt to make a purchase through our site, we collect certain information from you, including your name, billing address, shipping address, payment information, email address, and phone number. We refer to this information as "Order Information."
                </p>
              </section>

              <section>
                <h2 className="font-heading text-xl text-[#2C2420] mb-4">2. How We Use Your Information</h2>
                <p className="text-[#5D5550] leading-relaxed mb-4">
                  We use the Order Information that we collect generally to fulfill any orders placed through the site, including:
                </p>
                <ul className="list-disc pl-6 text-[#5D5550] space-y-2">
                  <li>Processing your payment information</li>
                  <li>Arranging for shipping</li>
                  <li>Providing you with invoices and/or order confirmations</li>
                  <li>Communicating with you about your order</li>
                  <li>Screening orders for potential risk or fraud</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading text-xl text-[#2C2420] mb-4">3. Sharing Your Information</h2>
                <p className="text-[#5D5550] leading-relaxed">
                  We share your Personal Information with third parties to help us use your Personal Information, as described above. For example, we use Stripe to power our online store and process payments. We also use analytics services to help us understand how our customers use the site.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-xl text-[#2C2420] mb-4">4. Data Retention</h2>
                <p className="text-[#5D5550] leading-relaxed">
                  When you place an order through the site, we will maintain your Order Information for our records unless and until you ask us to delete this information.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-xl text-[#2C2420] mb-4">5. Your Rights</h2>
                <p className="text-[#5D5550] leading-relaxed">
                  If you are a European resident, you have the right to access personal information we hold about you and to ask that your personal information be corrected, updated, or deleted. If you would like to exercise this right, please contact us.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-xl text-[#2C2420] mb-4">6. Cookies</h2>
                <p className="text-[#5D5550] leading-relaxed">
                  We use cookies to maintain your shopping cart and remember your preferences. You can control cookies through your browser settings.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-xl text-[#2C2420] mb-4">7. Contact Us</h2>
                <p className="text-[#5D5550] leading-relaxed">
                  For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by email at{' '}
                  <a href="mailto:prabalbansal11@gmail.com" className="text-[#C6A87C] hover:underline">
                    prabalbansal11@gmail.com
                  </a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </div>
    </Layout>
  );
};
